import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import UserAddress from '../Partials/UserAddress/UserAddress';
import { goToPage, setSelectedUserAddress, setIsReceivingAd, setFlowType, reportDWH, setIsSubmit, setPersonalInfo, setDeliveryAddress, setSelectedAddress } from '../saleJetBlockSlice';
import {getDeliveryTimeSlots, enterInternetAddPaymentMode} from '../saleBlockAsyncThunk';
// import {dwhThirdPartyConsentCheckboxDisplay} from "../../ChangePricePlanBlock/reports/dwhReports";
import {gtag4} from '../../../../utilities/analytics/tracking';
const UserAddressPage = (props) => {
  const [errorMsg, setErrorMsg] = useState('');
  let funnel_name = (props.flowType === 'newCustomer') ? '_New' : '_Exists';

  useEffect(() => {
    props.reportDWH({ actionType: 'Select Billing Account', status: 'Ongoing', messageText: 'Billing Account Page Displayed' });

    // if (props.showCollaborationApproval){
    //   dwhThirdPartyConsentCheckboxDisplay(props.userDetails.firstName + " " + props.userDetails.lastName, props.userDetails.contactNumber, props.userDetails.IDNumber, "מכר " + props.saleType)
    // }
    gtag4({
      event: props.saleType == 'cellular' ? 'cellular_Step10_ChooseAccountPage' : `${props.saleType}_Step7_ChooseAccountPage`,
      step: props.saleType == 'cellular' ? '10' :'7',
      action:'ChooseAccountPage',
      funnel_name:`${props.saleType}_Exists${funnel_name}_Customer`
    });
  }, []);

  //page params
  let isDisplayFooter = true;
  let title = props.saleType == 'cellular' ? 'לאיזה חשבון לשייך את החבילה?' : 'אוטוטו מסיימים';
  let subTitle = props.saleType == 'cellular' ? '' : 'בחירת חשבונית לחיוב';
  let btnText = props.saleType == 'cellular' ? 'בחרתי בואו נמשיך' : 'תשלום';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  // const isDisplayCheckboxIsReceivingBill = true; //props.saleType == "internet" || props.saleType == "cellular";
  // const isDisplayCheckboxReceivingAd = props.showCollaborationApproval;
  const isDisplaySeparateInvoice = false;
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'>{title}</h1>
      <h2 className='sale-title-small'>{subTitle}</h2>
    </div>
  );

  let currentPageView = (
    <div>
      <UserAddress
        userAddress={props.userAddresses}
        onSelectedAddress={onSelectedAddress}
        selectedAddress={props.selectedAddress}
        isSelectedSeparateInvoice={props.isSelectedSeparateInvoice}
        onSubmit={props.isSubmit}
        onValid={handlePageValidate}
        // isDisplayCheckboxIsReceivingBill={isDisplayCheckboxIsReceivingBill}
        // isDisplayCheckboxReceivingAd={isDisplayCheckboxReceivingAd}
        programDetailsLink={props.programDetailsLink}
        connectionAgreementLink={props.connectionAgreementLink}
        generalTermsAgreementLink={props.generalTermsAgreementLink}
        advertisingInfoLink={props.advertisingInfoLink}
        isDisplaySeparateInvoice={isDisplaySeparateInvoice}
        gtag4={gtag4}
        saleType={props.saleType}
        flowType={funnel_name}
      />
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content' style={{ paddingBottom: '150px' }}>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );

  function handlePageValidate(data) {
    props.setIsSubmit(false);
    if (data.isValid) {
      handlePageContinueAfterValid(data);
    }
  }

  function handlePageContinue() {
    props.setIsSubmit(true);
    gtag4({
      event: props.saleType == 'cellular' ? 'cellular_Step10_ChooseAccountContinueButton' : `${props.saleType}_Step7_ChooseAccountContinueButton`,
      step: props.saleType == 'cellular' ? '10' : '7',
      button: btnText,
      action:'ChooseAccountContinueButton',
      funnel_name:`${props.saleType}_Exists${funnel_name}_Customer`
    });
  }

  function handlePageContinueAfterValid(data) {
    props.reportDWH({ actionType: 'Select Billing Account', status: 'Ongoing', messageText: 'Billing Account Button Clicked' });

    // let isReceivingBill = data.isReceivingBill;
    // if (props.flowType == 'newCustomer' && (props.saleType == 'tv' || props.saleType == 'app' || props.saleType == 'triple')) {
    //   isReceivingBill = true;
    // }
    // props.setPersonalInfo({ isReceivingAd: data.isReceivingAd, isReceivingBill: isReceivingBill });

    if (props.isSelectedSeparateInvoice) {
      props.setFlowType('newCustomer');
      if (props.saleType === 'internet') {
        props.enterInternetAddPaymentMode();
      } else {
        props.goToPage('personalInfoPage');
      }
    }
    else if (props.saleType === 'internet') {
      // Fiber: existing BAN selected → create sale (new credit card path is paymentPage)
      props.goToPage('createSaleInProcess');
    }
    else {
      //----------------------------------
      if(props.saleType == 'cellular'){
        const address = {
          cityName: props.selectedAddress.cityName,
          streetName: props.selectedAddress.streetName,
          home: props.selectedAddress.home,
          apartment: props.selectedAddress.apartment,
        };
        props.setSelectedAddress(address);
        if(props.cellular.isDisplayDeliveryPage){
          if(!address.cityName || !address.streetName ){
            props.goToPage('deliveryAddressPage');
          }
          else{
            props.setDeliveryAddress(address);
            props.getDeliveryTimeSlots();
          }
        }
        else{
          if(props.flowType == 'existsCustomer'){
            props.goToPage('emailPage');
          }
          else{
            props.goToPage('summaryPage');
          }
        }
      }
      else{
        const hasTv = props.userAddressForUpgradePage.selectedAddress?.products?.find(x => x.type.toLowerCase() == 'tv');
        let isDisplayEmailPage = ((props.collectEmailOnProcess || props.saleType == 'tv' || props.saleType == 'app' || props.saleType == 'triple') && !hasTv);
        if (isDisplayEmailPage) {
          props.goToPage('emailPage');
        }
        else{
          props.goToPage('summaryPage');
        }
      }
      //----------------------------------
    }
  }

  function onSelectedAddress(address) {
    props.reportDWH({ actionType: 'Select Billing Account', status: 'Ongoing', messageText: 'Pick  Ban clicked' });
    gtag4({
      event: props.saleType == 'cellular' ? 'cellular_Step10_ChooseAccountButton' : `${props.saleType}_Step7_ChooseAccountButton`,
      step: props.saleType == 'cellular' ? '10' :'7',
      action:'ChooseAccountButton',
      funnel_name:`${props.saleType}_Exists${funnel_name}_Customer`
    });
    props.setSelectedUserAddress(address);
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    orderType: state.saleJetBlock.orderType,
    offerName: state.saleJetBlock.offerName,
    userAddresses: state.saleJetBlock.userAddressPage.userAddresses,
    selectedAddress: state.saleJetBlock.userAddressPage.selectedAddress,
    isSelectedSeparateInvoice: state.saleJetBlock.userAddressPage.isSelectedSeparateInvoice,

    programDetailsLink: state.saleJetBlock.selectedPackage.programDetailsLink,
    connectionAgreementLink: state.saleJetBlock.selectedPackage.connectionAgreementLink,
    generalTermsAgreementLink: state.saleJetBlock.saleBlockData.generalTermsAgreementLink,
    advertisingInfoLink: state.saleJetBlock.saleBlockData.advertisingInfoLink,

    // showCollaborationApproval: state.saleJetBlock.checkUserResponse.showCollaborationApproval,
    isSubmit: state.saleJetBlock.isSubmit,
    collectEmailOnProcess: state.saleJetBlock.checkUserResponse.collectEmailOnProcess,
    userAddressForUpgradePage: state.saleJetBlock.userAddressForUpgradePage,
    totalPrice: state.saleJetBlock.totalPrice,
    cellular: state.saleJetBlock.cellular,
    // userDetails: state.authentication.loginData.userDetails

    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedUserAddress,
  setIsReceivingAd,
  setFlowType,
  showAppLoader,
  hideAppLoader,
  reportDWH,
  setIsSubmit,
  setPersonalInfo,
  getDeliveryTimeSlots,
  enterInternetAddPaymentMode,
  setDeliveryAddress,
  setSelectedAddress
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAddressPage);
